import { createFileRoute } from '@tanstack/react-router'
import { RecentsPage } from '@/components/pages/RecentsPage'

export const Route = createFileRoute('/workspace/recents')({
  component: RecentsPage,
})
